<template>
  <div>
    <h4 class="mt-4 font-weight-bold text-secondary">
      <i class="fas fa-users"></i> สมาชิกที่แนะนำ
    </h4>
    <b-table
      striped
      hover
      :items="items"
      :fields="fields"
      small
      responsive
      show-empty
      emptyText="ไม่มีรายการ"
      id="my-table"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template #cell(allBet)="data">
        <span>{{data.item.amount.toLocaleString()}}</span>
      </template>
    </b-table>
    <div class="overflow-auto">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "Overview",
  data() {
    return {
      fields: [
        {
          key: "transactionDate",
          label: "วัน - เวลาที่สมัคร"
        },
        {
          key: "affiliateMemberName",
          label: "ยูสเซอร์เนม"
        },
        {
          key: "amount",
          label: "แทงทั้งหมด",
          thClass: "text-right",
          tdClass: "text-right"
        }
      ],
      perPage: 3,
      currentPage: 1,
      items: [
      ]
    };
  },
  mounted() {
    this.getResult();
  },  
  methods: {
    getResult() {
      axios.post(this.getApiUrl + "/affiliate/members",
        {
          CustomerCode: this.getUsername,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        })
        .then(response => {
          this.items = response.data.data;
          console.log('items', this.items);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getApiUrl: "getApiUrl"
    }),    
    rows() {
      return this.items.length;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>